const ENGLISH_IMAGE_MAP = {
  'home-about/about-1-nolive.png': 'home-about/about-1-nolive-english.png',
  'home-about/about-2.png': 'home-about/about-2-english.png',
  'home-about/about-3.png': 'home-about/about-3-english.png',
  'home-about/about-4.png': 'home-about/about-4-english.png',
  'product/four/2.png': 'product/four/2-english.png',
  'product/four/3.png': 'product/four/3-english.png',
  'product/one/3.png': 'product/one/3-english.png',
  'product/one/4.png': 'product/one/4-english.png',
  'product/three/3.png': 'product/three/3-english.png'
}

const ENGLISH_SUFFIX_FOLDERS = ['service/', 'product/two/']

const appendEnglishSuffix = (path) => path.replace(/(\.[^.]+)$/i, '-english$1')

export default {
  computed: {
    currentLocale() {
      if (this.$y18n && this.$y18n.locale) {
        return this.$y18n.locale.value
      }
      if (typeof this.$getLang === 'function') {
        return this.$getLang()
      }
      return 'zh'
    },
    isEnglishLocale() {
      return this.currentLocale === 'en'
    }
  },
  methods: {
    localizedImg(path) {
      if (!this.isEnglishLocale || !path) {
        return path
      }
      if (ENGLISH_IMAGE_MAP[path]) {
        return ENGLISH_IMAGE_MAP[path]
      }
      if (ENGLISH_SUFFIX_FOLDERS.some((prefix) => path.startsWith(prefix))) {
        return appendEnglishSuffix(path)
      }
      return path
    }
  }
}
